import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { LogIn, ArrowLeft } from "lucide-react";
import { login, setToken } from "@/lib/api";
import Spinner from "@/components/Spinner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await login(email, password);
      setToken(r.data.token);
      toast.success("Kirjautuminen onnistui");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Kirjautuminen epäonnistui");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0D10] text-white grid place-items-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white mb-8">
          <ArrowLeft size={16} /> Etusivulle
        </Link>
        <div className="md-card p-8 md:p-10">
          <div className="flex items-center gap-3 mb-6">
            <span className="inline-flex items-center justify-center rounded-xl bg-white px-3 py-2">
              <img src="/myyntidrive-logo.png?v=7" srcSet="/myyntidrive-logo.png?v=7 1x, /myyntidrive-logo@2x.png?v=7 2x" alt="MyyntiDrive" className="h-8 w-auto block" />
            </span>
            <div>
              <div className="font-display text-xl font-bold">Admin</div>
              <div className="text-xs text-white/50">MyyntiDrive hallintapaneeli</div>
            </div>
          </div>
          <form onSubmit={onSubmit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <Label className="text-white/80 mb-2 block">Sähköposti</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="bg-[#0B0D10] border-white/10 text-white h-11"
                data-testid="admin-email"
              />
            </div>
            <div>
              <Label className="text-white/80 mb-2 block">Salasana</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="bg-[#0B0D10] border-white/10 text-white h-11"
                data-testid="admin-password"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="md-btn-primary w-full justify-center disabled:opacity-70"
              data-testid="admin-login-submit"
            >
              {loading ? <Spinner size="sm" label="Kirjaudutaan..." /> : "Kirjaudu sisään"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
